export const DialogTitle = 'Sale Confirmation';
export const ToogleInvoiceFields = ['OutputInvoice', 'OutputSalesDocket', 'OutputBarcodeLabel'];
